module.exports = __webpack_public_path__ + "static/media/icon-peinture.b7a3a22e.svg";